import type { ThemePreference } from './resolveTheme';

export const THEME_STORAGE_KEY = 'glyyd-theme';

const ALLOWED: ThemePreference[] = ['light', 'dark', 'system'];

export function readThemePreference(): ThemePreference {
  try {
    const raw = localStorage.getItem(THEME_STORAGE_KEY);
    if (raw && (ALLOWED as string[]).includes(raw)) return raw as ThemePreference;
  } catch {
    /* private mode */
  }
  return 'light';
}

export function writeThemePreference(preference: ThemePreference): void {
  try {
    localStorage.setItem(THEME_STORAGE_KEY, preference);
  } catch {
    /* ignore */
  }
}
